export class LocalStorageKeys {
  static brand_access_token = "brand_access_token";
  static brand_temporary_access_token = "brand_temporary_access_token";
  static user_data = "user_data";
  static agency_data = "agency_data";
  static agent_data = "agent_data";
  static registration_data = "registration_data";
  static session_user_type = "session_user_type";
  // static mylo_user_access_token = "mylo_user_access_token";
  // static mylo_user_question_id ="mylo_user_question_id"
}

export class QuestionStatus {
  static DRAFT = "draft";
  static FINALIZED = "finalized";
  static PENDING = "pending";
  static INCOMING = "incoming";
  static ACCEPTED = "accepted";
  static ACTIVE = "active";
  static REJECTED = "rejected";
  static UNANSWERED = "unanswered";
  static INAPPROPRIATE = "INAPPROPRIATE";
  static CANCELLED = "cancelled";
}

export class CommonUtils {
  /**
   * Reads a File object (from an input) and returns its content as a promise resolving to an ArrayBuffer.
   * This is the standard way to get raw binary data from a file on the client-side.
   * @param {File} file - The image file object from the input event.
   * @returns {Promise<ArrayBuffer>} The file data as an ArrayBuffer.
   */
  static fileToArrayBuffer = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const arrayBuffer = event.target.result;

        // Create a NEW Blob from the ArrayBuffer, preserving the original MIME type
        const newBlob = new Blob([arrayBuffer], { type: file.type });

        resolve(newBlob);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      // Read the file's binary content
      reader.readAsArrayBuffer(file);
    });

    // return new Promise((resolve, reject) => {
    //   const reader = new FileReader();

    //   // Event fires when the read operation is successfully completed
    //   reader.onload = (event: any) => {
    //     // event.target.result contains the file data as an ArrayBuffer
    //     resolve(event.target.result);
    //   };

    //   // Event fires if the read operation fails
    //   reader.onerror = (error) => {
    //     reject(error);
    //   };

    //   // Read the file's binary content
    //   reader.readAsArrayBuffer(file);
    // });
  };

  /**
   * Get fullname for the agent using agent data
   * @param {PrincipalAgent} agentData
   * @returns
   */
  static getAgentName = (agentData: any) => {
    let userData: any = agentData;

    let agentName = "";

    agentName = `${userData?.principal_agent_first_name} ${userData?.principal_agent_last_name}`;

    return agentName;
  };
}
